import { isEmpty } from 'lodash';
import { EMPTY_NUMBER_FIELD_VALUE, ONLY_DIGITS_REGEX } from '../constants/patterns';

const handleChange = (key, value, setForm, setValue, shouldValidate = true) => {
  setForm((prevState) => ({
    ...prevState,
    [key]: value,
  }));
  setValue(key, value, shouldValidate);
};

export const setDataFormValues = (data, setValue) => {
  Object.keys(data).forEach((key) => {
    setValue(key, data[key]);
  });
};

export const triggerDataValidations = (keys, errors, triggerValidation) => {
  keys.forEach((key) => {
    if (errors[key]) {
      triggerValidation({ name: key });
    }
  });
};

export default handleChange;

export const changeRecurringPaymentRowPriceField = (value, row) => {
  if (!value.match(ONLY_DIGITS_REGEX) && !isEmpty(value)) {
    return;
  }

  const currentValue = value || EMPTY_NUMBER_FIELD_VALUE;

  const { maxPayable } = row;

  let valueToSet = currentValue === '' ? '' : parseInt(currentValue, 10);

  if (valueToSet && valueToSet > maxPayable) {
    valueToSet = maxPayable;
  }

  // eslint-disable-next-line consistent-return
  return valueToSet;
};
